module.exports = __webpack_public_path__ + "static/img/fontello.9354499c.svg";